// SubscriptionStatusAlert.jsx
// ─────────────────────────────────────────────────────────────────────────
// Extraído de CreateSurvey.jsx / EditSurvey.jsx, donde el mismo bloque
// (formatPeriodEnd + el cálculo de isCancelPending + el <Alert> de aviso)
// vivía duplicado carácter por carácter en los dos archivos. Ahora es un
// único componente MUI que ambos importan.
import { Container, Alert } from '@mui/material';

/** Formatea la fecha de fin de período, cubriendo ambas formas en que
 * Firestore serializa Timestamps (.seconds y ._seconds). */
export const formatPeriodEnd = (subscription, lang) => {
  const seconds =
    subscription?.current_period_end?.seconds ??
    subscription?.current_period_end?._seconds ??
    null;
  if (!seconds) return null;
  return new Date(seconds * 1000).toLocaleDateString(
    lang === 'es' ? 'es-MX' : 'en-US',
    { year: 'numeric', month: 'long', day: 'numeric' },
  );
};

/**
 * Aviso "tu suscripción fue cancelada pero sigue activa hasta X fecha".
 * No renderiza nada si no aplica, así que puede colocarse incondicionalmente
 * en el árbol (evita el `isCancelPending && (...)` repetido en cada página).
 */
const SubscriptionStatusAlert = ({ subscriptionActive, subscription, lang }) => {
  const isCancelPending = subscriptionActive && subscription?.cancel_at_period_end === true;
  if (!isCancelPending) return null;

  const periodEndDate = formatPeriodEnd(subscription, lang);

  return (
    <Container maxWidth="lg" sx={{ pt: 2, pb: 0 }}>
      <Alert severity="warning" variant="outlined" sx={{ borderRadius: 2 }}>
        {lang === 'es'
          ? `Tu suscripción fue cancelada. Las funciones Pro estarán disponibles${
              periodEndDate ? ` hasta el ${periodEndDate}` : ' hasta que finalice tu período actual'
            }.`
          : `Your subscription was cancelled. Pro features will remain available${
              periodEndDate ? ` until ${periodEndDate}` : ' until your current period ends'
            }.`}
      </Alert>
    </Container>
  );
};

export default SubscriptionStatusAlert;